import { render, staticRenderFns } from "./SupportChatPopup.vue?vue&type=template&id=39fe68ad&scoped=true&"
import script from "./SupportChatPopup.vue?vue&type=script&lang=ts&"
export * from "./SupportChatPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SupportChatPopup.vue?vue&type=style&index=0&id=39fe68ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe68ad",
  null
  
)

export default component.exports